export default "__VITE_ASSET__efe3442a__"